import styled, { css } from 'styled-components';
import { media, colors } from '@prisjakt/ui-base';

type PlaceholderProps = {
  rules: {
    media: keyof typeof media;
    width: number; // px
    height: number; // px
    margin: string; // CSS margin string
  }[];
};

export const Placeholder = styled.div<PlaceholderProps>(({ rules }) =>
  css(
    {
      position: 'relative',
      boxSizing: 'content-box',
      border: `1px solid ${colors.lightGray2}`,
      display: 'none',
    },
    ...rules.map(
      rule => media[rule.media]`
        display: block;
        width: ${rule.width}px;
        max-width: 100vw;
        margin: ${rule.margin};
        &::after {
          content: '';
          display: block;
          padding-top: ${(100 * rule.height) / rule.width}%;
        }`
    )
  )
);
